import { DatePicker } from 'antd';
import ptBR from 'antd/es/date-picker/locale/pt_BR';
import dayjs, { Dayjs } from 'dayjs';
import 'dayjs/locale/pt-br';
import './filtroDeDatas.css';

dayjs.locale('pt-br');

export type IntervaloDeDatas = [Dayjs | null, Dayjs | null] | null;

const hoje = () => dayjs();
const ATALHOS: { label: string; value: () => [Dayjs, Dayjs] }[] = [
    { label: 'Hoje', value: () => [hoje().startOf('day'), hoje().endOf('day')] },
    { label: 'Ontem', value: () => [hoje().subtract(1, 'day').startOf('day'), hoje().subtract(1, 'day').endOf('day')] },
    { label: 'Últimos 7 dias', value: () => [hoje().subtract(6, 'day').startOf('day'), hoje().endOf('day')] },
    { label: 'Últimos 30 dias', value: () => [hoje().subtract(29, 'day').startOf('day'), hoje().endOf('day')] },
    { label: 'Este mês', value: () => [hoje().startOf('month'), hoje().endOf('day')] },
    { label: 'Mês passado', value: () => [hoje().subtract(1, 'month').startOf('month'), hoje().subtract(1, 'month').endOf('month')] },
    { label: 'Últimos 90 dias', value: () => [hoje().subtract(89, 'day').startOf('day'), hoje().endOf('day')] },
    { label: 'Este ano', value: () => [hoje().startOf('year'), hoje().endOf('day')] },
];

/** O intervalo vale do começo do primeiro dia ao fim do último; vazio de um lado, sem limite. */
export function dentroDoIntervalo(instante: number, intervalo: IntervaloDeDatas) {
    if (!intervalo) return true;
    const [de, ate] = intervalo;
    if (de && instante < de.startOf('day').valueOf()) return false;
    if (ate && instante > ate.endOf('day').valueOf()) return false;
    return true;
}

interface IProps {
    value: IntervaloDeDatas;
    onChange: (v: IntervaloDeDatas) => void;
    /** O que a data significa, no texto de dentro do campo: "Enviado", "Gerado". */
    rotulo: string;
    className?: string;
}

/**
 * Filtro de datas em português: um campo só, com atalhos (hoje, últimos 7 dias, este
 * mês...) no próprio calendário. Datas futuras ficam bloqueadas, e qualquer um dos
 * lados pode ficar vazio ("desde" ou "até").
 */
export function FiltroDeDatas({ value, onChange, rotulo, className }: IProps) {
    return (
        <DatePicker.RangePicker
            className={`filtro-datas${className ? ` ${className}` : ''}`}
            locale={ptBR}
            format="DD/MM/YYYY"
            placeholder={[`${rotulo} de`, 'até']}
            value={value}
            onChange={v => onChange(v && (v[0] || v[1]) ? (v as IntervaloDeDatas) : null)}
            presets={ATALHOS.map(a => ({ label: a.label, value: a.value() }))}
            allowEmpty={[true, true]}
            allowClear
            disabledDate={d => d.isAfter(dayjs().endOf('day'))}
        />
    );
}
